import { PayService } from '@scorewarrior/rubens_web_lib/lib/payservice';
import { getProjectNameByCurrentPlatform } from '../constants/projectName';
import { payServiceLoggingAdapter } from './payServiceLoggingAdapter';

export function getPayServiceClient(): PayService {
    const client = new PayService(
        window.app.config.payservice_url,
        getProjectNameByCurrentPlatform(),
        window.app.config.user_auth_token
    );
    client.setLoggingAdapter(payServiceLoggingAdapter);
    return client;
}
